import { Controller } from '@hotwired/stimulus';

import { postWebViewSuccessMessage } from '../../apps/AddGoal/postWebViewSuccessMessage';

export default class extends Controller {
  static values = { goalId: Number, accountId: Number };

  declare readonly goalIdValue: number;

  declare readonly accountIdValue: number;

  connect() {
    postWebViewSuccessMessage({
      eventName: 'goal_setup_complete',
      goalId: this.goalIdValue,
      accountId: this.accountIdValue,
    });
  }
}
